<template>
<div class="img">
    <img src="../assets/images/banner/chemical.jpg" alt="">
</div>

</template>

<script>

export default ({
    name: 'nutraC', 
})

</script>

<style scoped>
.img{
    width: 100vw;
    height: auto;
    overflow-x: hidden
}

.img img{
    width: 100vw;
    height: auto;
}

</style>